export enum Roles {
    Admin = 'Admin',
    Bot = 'Bot',
    Super = 'Super',
    Staff = 'Staff',
    User = 'User',
}
export enum OrgRoles {
    OrgOwner = 'OrgOwner',
    OrgController = 'OrgController',
    OrgMember = 'OrgMember',
}
export enum Scopes {
    OrganizationAdmin = 'organization:admin',
    OrganizationListRead = 'organization-list:read',
    OrganizationRead = 'organization:read',
    OrganizationUserRead = 'organization-user:read',
    OrganizationWrite = 'organization:write',
    TokenRefresh = 'token:refresh',
    UserDelete = 'user:delete',
}
